import { call, put } from 'redux-saga/effects'
import { RequestMethods } from 'utils/axios/methods'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Actions_Notifications } from 'redux/modules/notification/Actions'
import { sagaAction_Error } from 'redux/sagas/actions/SagaAction_Error'
import { Actions_CurrentUser } from 'redux/modules/currentUser/Actions'
import { Actions_Modals } from 'redux/modules/modals/Actions'
import { TStoreTemplate } from 'redux/config/root-types'
import { IRentFull } from 'redux/modules/rents/TReducer'
import { Actions_Rents } from 'redux/modules/rents/Actions'

const client = RequestMethods()

export interface ISagaWorker_СhangeRentFinishParking {
  rentId: string
  parkingId: number
}

export default function* SagaWorker_СhangeRentFinishParking(
  action: PayloadAction<ISagaWorker_СhangeRentFinishParking>,
) {
  yield put(Actions_CurrentUser.store.showLoader())

  try {
    yield call(
      async () =>
        await client.put<null>(`/rents/${action.payload.rentId}/finishParking`, {
          parkingId: action.payload.parkingId,
        }),
    )

    const rent: TStoreTemplate<IRentFull> = yield call(
      async () => await client.get<IRentFull>(`/rents/${action.payload.rentId}`),
    )

    yield put(Actions_Rents.store.setUserRent(rent.data))

    yield put(
      Actions_Notifications.store.setNotification({
        message: 'Rent finish parking successfully choose',
        type: 'Success',
      }),
    )
    yield put(Actions_Modals.store.hideModal())
  } catch (e) {
    yield call(() => sagaAction_Error(e))
  } finally {
    yield put(Actions_CurrentUser.store.hideLoader())
  }
}
